import { useState, useEffect } from 'react'
import ToastNotification from './ToastNotification'
import CustomDialog from './CustomDialog'
import ContextsProvider from './ContextsProvider'
import useLoginHandler from './hooks/useLoginHandler'
import useDialog from './hooks/useDialog'
import useAuth from './hooks/useAuth'
import useFetchSystemJson from './hooks/useFetchSystemJson'
import LoadingPulse from '../../components/Loading/LoadingPulse'
import MaintenanceMode from '../../components/MaintenanceMode/MaintenanceMode'
import Pages from '../app/Pages/Pages'
import LoginRouter from '../Login/LoginRouter'
import logRedirect from '../../helper/RedirectLogger'

// TODO: Get from Fileserver
const forbiddenTenantsInSearch = [87, 947, 1777, 1821]

const maintenanceValue = process.env.REACT_APP_MAINTENANCE
const isMaintenanceMode = !!maintenanceValue && maintenanceValue.length > 0

const Router = () => {
	const [systemJson, setSystemJson] = useState({})
	const [activeDropdown, setActiveDropdown] = useState(null)

	const { auth, profile, access, loading, LoginHandler, setLoading } =
		useLoginHandler(forbiddenTenantsInSearch)
	const { dialogStructure, setDialogStructure, openDialog, openDialogHandler } =
		useDialog()

	useAuth(LoginHandler, setLoading, auth)
	useFetchSystemJson(setSystemJson, forbiddenTenantsInSearch)

	useEffect(() => {
		logRedirect('Router', {
			hasAuth: !!auth,
			loading,
			rendering: auth ? 'Pages' : 'LoginRouter',
			action: 'Auth state changed',
		})
	}, [auth, loading])

	// Block everything if maintenance mode is enabled
	if (isMaintenanceMode) {
		return <MaintenanceMode />
	}

	return (
		<ContextsProvider
			systemContext={{
				systemJson,
				setDialogStructure,
				openDialogHandler,
				dropdownState: [activeDropdown, setActiveDropdown],
				LoginHandler,
			}}
			userContext={{ profile, auth, access, token: auth?.access_token }}
		>
			<LoadingPulse
				isFullScreen
				visible={loading}
				className="items-center w-full"
				biggerDelay={true}
			>
				<>{auth ? <Pages /> : <LoginRouter />}</>
			</LoadingPulse>
			<ToastNotification />
			<CustomDialog
				open={openDialog}
				handler={openDialogHandler}
				dialogStructure={dialogStructure}
			/>
		</ContextsProvider>
	)
}

export default Router
